import { Adapter } from './adapter';
import { CourseAdditionalFields } from '@app/enums/_index';
import { SearchObject } from '../models/_index';
import { SearchObjectInterface } from '@app/interfaces/_index';
import { getSubscriptionTuple } from '@app/utilities/_index';

/**
 * Adapts raw service Docebo search object to Search Object model
 * NOTE: The item fields are the default json property names.
 */
export class SearchObjectAdapter implements Adapter<SearchObject> {
  /**
   * Search Object response interface is used to display Catalog search response from the DLP Lambdas
   * @param item has search object response Search Object Interface
   * @returns - adapted search object to Search object model
   */
  adapt(item: SearchObjectInterface): SearchObject {
    let searchObject: SearchObject;
    if (item && item.data) {
      let parentId = -1;
      let parentSlug = '';
      // NOTE: Docebo doesn't have parent subscription id mapped to a course response.
      // NOTE: subscription id = 84 is Genesys Cloud Learning Subscription
      // NOTE: subscription id = 189 is PureConnect Learning Subscription
      // NOTE: subscription id = 190 is Genesys Engage Learning Subscription
      // NOTE: subscription id = 497 (Docebo Sandbox and Docebo Production) is Pointillist Learning Subscription
      if (item.data.category && item.data.category.name) {
        const subscriptionTupleObject = getSubscriptionTuple(item.data.category.name);
        parentId = subscriptionTupleObject.subscriptionId;
        parentSlug = subscriptionTupleObject.subscriptionSlug;
      }

      let instructionType = '';
      let duration_days;
      let duration_mins;
      let isFreeCourse = false;

      if (item.data.additional_fields) {
        const additionalFields = item.data.additional_fields;
        // TODO: Rewrite this to use map and find
        additionalFields &&
          additionalFields.forEach((field) => {
            // NOTE: Allow == type coercion, DO NOT use === coercion
            // eslint-disable-next-line
            if (field && field.id && field.id == CourseAdditionalFields.INSTRUCTION_TYPE) {
              instructionType = field.value;
            }

            // eslint-disable-next-line
            if (field && field.id && field.id == CourseAdditionalFields.COURSE_DURATION_DAYS) {
              duration_days = field.value;
            }

            // eslint-disable-next-line
            if (field && field.id && field.id == CourseAdditionalFields.COURSE_DURATION_MINS) {
              duration_mins = field.value;
            }

            // eslint-disable-next-line
            if (field && field.id && field.id == CourseAdditionalFields.IS_FREE_COURSE) {
              const isFreeCourseState = field.value;
              // NOTE: IsFreeCourse from docebo is either 'True' or 'False' string
              if (isFreeCourseState && isFreeCourseState.toLowerCase() === 'true') {
                isFreeCourse = true;
              } else {
                isFreeCourse = false;
              }
            }
          });
      }

      searchObject = new SearchObject(
        parentId,
        parentSlug,
        item.data.id,
        item.data.name,
        item.data.code,
        item.data.description,
        duration_days,
        duration_mins,
        item.data.type,
        item.data.slug_name,
        instructionType,
        [],
        [],
        isFreeCourse
      );
    }
    return searchObject;
  }
}
